export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["MESSAGE_ADMIN_SAAS_FIRST_PART"] = "eulaAlert.MESSAGE_ADMIN_SAAS_FIRST_PART";
    TranslationsKeys["MESSAGE_ADMIN_SAAS_SECOND_PART"] = "eulaAlert.MESSAGE_ADMIN_SAAS_SECOND_PART";
    TranslationsKeys["MESSAGE_ADMIN_SAAS_LINK"] = "eulaAlert.MESSAGE_ADMIN_SAAS_LINK";
    TranslationsKeys["DIALOG_EMAIL_LABEL"] = "eulaAlert.DIALOG_EMAIL_LABEL";
    TranslationsKeys["ALREADY_SIGN_MESSAGE"] = "eulaAlert.ALREADY_SIGN_MESSAGE";
    TranslationsKeys["DIALOG_SIGN_SUCCESS"] = "eulaAlert.DIALOG_SIGN_SUCCESS";
    TranslationsKeys["SIGN_ACTION"] = "eulaAlert.SIGN_ACTION";
    TranslationsKeys["LEGAL_NAME"] = "adminSection.system.legal.name";
    TranslationsKeys["USER_AGREEMENT_NAME"] = "adminSection.system.userAgreement.name";
    TranslationsKeys["USER_AGREEMENT_DESCRIPTION_FIRST_PART_EULA_SIGNED"] = "adminSection.system.userAgreement.description_first_part";
    TranslationsKeys["USER_AGREEMENT_DESCRIPTION_FIRST_PART_EULA_NOT_SIGNED"] = "adminSection.system.userAgreement.description_first_part_not_signed";
    TranslationsKeys["USER_AGREEMENT_DESCRIPTION_LINK"] = "adminSection.system.userAgreement.description_link";
    TranslationsKeys["USER_AGREEMENT_DESCRIPTION_SECOND_PART"] = "adminSection.system.userAgreement.description_second_part";
})(TranslationsKeys || (TranslationsKeys = {}));
export var EulaDataMessage;
(function (EulaDataMessage) {
    EulaDataMessage["EULA_ALREADY_SIGNED"] = "EULA is already signed";
    EulaDataMessage["EULA_SIGNED_SUCCESSFULLY"] = "EULA is signed successfully";
})(EulaDataMessage || (EulaDataMessage = {}));
//# sourceMappingURL=constants.js.map